import React from "react";
import useQuestion1 from "./hook";

const FirstQuestion = () => {
    const {
        user,
        selectedResponse,
        selectRes
    } = useQuestion1();

    return (
        <React.Fragment>
            {
                user.gender === "Female" ? (
                    // eslint-disable-next-line
                    <img
                        src="/images/pregun1.jpg"
                        alt="Background Image Question 1"
                        className="background-question-1"
                    />
                ) : (
                    // eslint-disable-next-line
                    <img
                        src="/images/preguntahombre1.jpg"
                        alt="Background Image Question 1"
                        className="background-question-1"
                    />
                )
            }
            <div className="true-response" onClick={() => selectedResponse(true, 'first')}>
                {
                    selectRes.response && (
                        <img src="/images/true-hover.png" alt="True Response Hover"/>
                    )
                }
            </div>
            <div className="false-response" onClick={() => selectedResponse(false, 'first')}>
                {
                    selectRes.response === false  && (
                        <img src="/images/false-hover.png" alt="False Response Hover"/>
                    )
                }
            </div>
        </React.Fragment>
    );
}

export default FirstQuestion;